// 06-10 — Una bandeja por persona (Pau: «que Carlos y Santi tengan la suya y usen la suya»). Cada agente es de
// quien lo contrató (`dueno` del contratado); cada uno ve por defecto SU bandeja y puede mirar la de otro con el
// selector (Pau, 06-10: lo de los socios no sale en la suya). Es un filtro de la vista, no un cerrojo: los tres tienen los mismos permisos. PURO (sin React).
// Diseño: docs/cuentas-personales.md, «Bandejas por persona».
import type { ContratadoDTO } from '../compartido/vocabulario';
import { leToca } from './situacion';

/** La bandeja de Pau (el titular) se llama así; la de un socio, por el id de su cuenta. */
export const BANDEJA_TITULAR = 'titular';

/** Quién mira: lo que devuelve /api/auth/me. */
export interface Yo {
  rol: 'titular' | 'socio';
  cuentaId?: string | null;
}

export function bandejaDe(c: Pick<ContratadoDTO, 'dueno'>): string {
  return c.dueno?.cuentaId ?? BANDEJA_TITULAR;
}

/** La bandeja propia. Sin cuenta personal (contraseña compartida, o aún sin saber quién es) es la de Pau. */
export function miBandeja(yo: Yo | null): string {
  return yo && yo.rol === 'socio' && yo.cuentaId ? yo.cuentaId : BANDEJA_TITULAR;
}

export interface PestanaBandeja {
  clave: string;
  /** Nombre de pila del dueño; la propia lleva `propia` y la web la llama «Mía». */
  nombre: string;
  propia: boolean;
  /** Cuántos agentes vivos tiene. */
  agentes: number;
  /** Cuántos esperan algo de su dueño (permiso, no pueden seguir, le han escrito). */
  teToca: number;
}

const nombreDePila = (n: string) => n.trim().split(/\s+/)[0] || n;

/**
 * Las pestañas del selector: la propia primero (aunque esté vacía) y después las de los demás que tengan algún
 * agente, Pau delante de los socios. Con una sola pestaña no hace falta selector (la web no lo pinta).
 */
export function pestanasBandeja(todos: ContratadoDTO[], mia: string): PestanaBandeja[] {
  const por = new Map<string, PestanaBandeja>();
  por.set(mia, { clave: mia, nombre: '', propia: true, agentes: 0, teToca: 0 });
  for (const c of todos) {
    const clave = bandejaDe(c);
    const p = por.get(clave) ?? { clave, nombre: '', propia: false, agentes: 0, teToca: 0 };
    p.nombre = nombreDePila(c.dueno?.nombre ?? 'Pau');
    p.agentes += 1;
    if (leToca(c)) p.teToca += 1;
    por.set(clave, p);
  }
  const [propia, ...resto] = [...por.values()];
  resto.sort((a, b) => (a.clave === BANDEJA_TITULAR ? -1 : b.clave === BANDEJA_TITULAR ? 1 : a.nombre.localeCompare(b.nombre, 'es')));
  return [propia!, ...resto];
}

/** La bandeja que se ve: la que se está mirando si sigue teniendo agentes; si no, la propia. */
export function claveVisible(pestanas: PestanaBandeja[], vista: string | null, mia: string): string {
  return vista && pestanas.some((p) => p.clave === vista) ? vista : mia;
}

export function enBandeja(todos: ContratadoDTO[], clave: string): ContratadoDTO[] {
  return todos.filter((c) => bandejaDe(c) === clave);
}
